import { AxiosInstance, AxiosResponse } from "axios";
import AutocompleteApi from "@/common/api/AutocompleteApi";
import { axiosInstance } from "@/plugins/axios";
import { Api } from "@/common/api/Api";
import SensorRouter from "@/context/sensor/router/SensorRouter";
import { SensorAutocompleteModel } from "@/context/sensor/model/SensorAutocompleteModel";

export class SensorApi extends Api {
  constructor(axios: AxiosInstance) {
    super(SensorRouter.BASE_PATH, axios);
  }

  public static async findAutocomplete(
    search: string,
    query: string
  ): Promise<Array<SensorAutocompleteModel>> {
    const response: AxiosResponse = await AutocompleteApi.findAutocomplete(
      SensorRouter.BASE_PATH,
      search,
      query
    );
    return response.data;
  }

  public static async findPage(query: string): Promise<AxiosResponse> {
    const response: AxiosResponse = await axiosInstance.get(SensorRouter.BASE_PATH + "/p?" + query);
    return response;
  }

  public static async delete(id: number): Promise<AxiosResponse> {
    const response: AxiosResponse = await axiosInstance.delete(SensorRouter.BASE_PATH + "/" + id);
    return response;
  }
}

export const sensorApi = new SensorApi(axiosInstance);
